import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";

import { cn } from "../../lib/utils";
import { buttonVariants } from "./button";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  disabled,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-between items-center",
        caption_label:
          "BookEZ_font_body_size BookEZ_font_bold BookEZ_font_color_gray_2",
        nav: "flex items-center",
        nav_button: cn(
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 flex items-center"
        ),
        nav_button_previous: "",
        nav_button_next: "",
        table: "w-full border-collapse space-y-1",
        head_row: "flex gap-2",
        head_cell:
          "BookEZ_font_color_gray_1 BookEZ_rounded_xl w-9 BookEZ_font_body_size",
        row: "flex w-full mt-2 gap-2",
        cell: "h-9 w-9 text-center BookEZ_font_body_size BookEZ_font_color_gray_2 p-0 relative focus-within:relative focus-within:z-20",
        day: cn(
          buttonVariants({ variant: "default" }),
          "h-9 w-9 p-0 BookEZ_calender BookEZ_font_normal aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected:
          "BookEZ_calender BookEZ_calender_selected_color BookEZ_font_body_medium",
        day_today: "bg-accent text-accent-foreground",
        day_outside:
          "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "BookEZ_calender_disabled_color opacity-50",
        day_range_middle:
          "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ ...props }) => (
          <ChevronLeft className="h-4 w-4 BookEZ_font_color_gray_2" />
        ),
        IconRight: ({ ...props }) => (
          <ChevronRight className="h-4 w-4 BookEZ_font_color_gray_2" />
        ),
      }}
      disabled={disabled}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
